import React, { Component, PureComponent } from 'react'
import { Button, Image, Section } from 'components'
import { ICONS } from 'themes'
import { ROUTE_PATH, STRING } from 'helpers'
export default class Header extends PureComponent {
  render() {
    return (
      <Section className="page-topbar">
        <Section className="page-header">
          <Section className="page-icon">
            <Image
              id="page_icon_supplier_form"
              src={ICONS['icon-user-white.svg']}
              alt="page icon"
            />
          </Section>

          <Section className="title-and-breadcrumb">
            <Section id="page_title_supplier_form" className="title">
              Supplier Management
            </Section>

            <Section id="page_breadcrumb_supplier_form" className="breadcrumbs">
              <Button
                className="breadcrumb"
                onClick={() => {
                  this.props.history.push(ROUTE_PATH.HOME.LINK)
                }}
              >
                <span>{STRING.HOME}</span>
              </Button>

              <Button
                onClick={() => {
                  this.props.history.push(
                    ROUTE_PATH.SUPPLIER_MANAGEMENT_ADMIN.LINK
                  )
                }}
                className="breadcrumb"
              >
                <span>Supplier Management</span>
              </Button>

              <Button className="breadcrumb current">
                <span>Edit User</span>
              </Button>
            </Section>
          </Section>
        </Section>
      </Section>
    )
  }
}
